<template>
  <div class="banner-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <!-- 表格 -->
        <div class="filter-box">
          <div class="left">
            <div class="label">是否热门品牌：</div>
            <el-select
              v-model="filter.hotBrand"
              size="small"
              class="select"
              style="width: 153px"
              placeholder="请选择"
            >
              <el-option :value="0" label="全部"> </el-option>
              <el-option :value="1" label="是"> </el-option>
              <el-option :value="2" label="否"> </el-option>
            </el-select>
            <el-input
              class="input"
              v-model="filter.brandName"
              style="width: 188px; margin-left: 10px"
              placeholder="此框输入品牌名搜索"
              size="small"
            ></el-input>
            <div class="btn-box">
              <button class="search" @click="search">搜索</button>
              <button class="reset" @click="reset">重置</button>
            </div>
          </div>
          <div class="right">
            <div class="btn" @click="toDetail('add')">+添加品牌</div>
          </div>
        </div>
        <el-table
          :data="list"
          class="order-table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column
            prop="id"
            align="center"
            label="品牌ID"
          ></el-table-column>
          <el-table-column prop="logo" align="center" label="Logo">
            <div slot-scope="scope">
              <el-image
                class="brand-pic"
                :src="scope.row.logo"
                :preview-src-list="[scope.row.logo]"
              >
              </el-image>
            </div>
          </el-table-column>
          <el-table-column
            prop="brandName"
            align="center"
            label="品牌名称"
          ></el-table-column>
          <el-table-column
            prop="categoryName"
            align="center"
            label="主营品类"
            width="500"
          >
            <div slot-scope="scope">{{ scope.row.categoryName.join('，') }}</div>
          </el-table-column>
          <el-table-column prop="hotBrand" align="center" label="是否选为热门">
            <div
              slot-scope="scope"
              @click="changeBrandHot(scope.row.id, scope.row.hotBrand)"
            >
              <i
                v-if="scope.row.hotBrand === 1"
                class="iconfont icon-xuanzye checked-icon"
                style="color: #6B95FF;"
              ></i>
              <i v-else class="iconfont icon-weixzye"></i>
              {{ scope.row.hotBrand === 1 ? "是" : "否" }}
            </div>
          </el-table-column>
          <el-table-column
            prop="sort"
            align="center"
            label="排序"
          ></el-table-column>
          <el-table-column label="操作" align="center" width="360">
            <div
              slot-scope="scope"
              style="display: flex;justify-content: center;"
            >
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="getSeriesList(scope.row.id)"
                >
                  系列
                </button>
              </div>
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="toDetail('edit', scope.row.id)"
                >
                  编辑
                </button>
              </div>
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="deleteBrand(scope.row.id)"
                >
                  删除
                </button>
              </div>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <div class="footer">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          background
          layout="total, prev, pager, next, jumper"
          :page-size="size"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="系列" width="480px" :visible.sync="seriesVisible">
      <div class="series-box">
        <el-table
          :data="seriesList"
          class="order-table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column
            prop="seriesName"
            align="center"
            label="系列名称"
          ></el-table-column>
          <el-table-column
            prop="sort"
            align="center"
            label="系列排序"
          ></el-table-column>
          <el-table-column label="操作" align="center" width="90">
            <div
              slot-scope="scope"
              style="display: flex;justify-content: center;"
            >
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="deleteSeries(scope.row.id)"
                >
                  删除
                </button>
              </div>
            </div>
          </el-table-column>
        </el-table>
        <div class="add-btn" @click="addSericeModal">+ 添加系列</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn confirm-btn" @click="seriesVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="addSericevisible"
      class="dialog"
      width="400px"
      top="25vh"
    >
      <div slot="title" class="dialog-title">
        {{ (type === "add" ? "新建" : "编辑") + "系列" }}
      </div>
      <el-form
        ref="form"
        :model="addSericeForm"
        class="form"
        label-width="auto"
      >
        <el-form-item label="系列名称:" prop="seriesName" class="form-item">
          <el-input
            size="small"
            placeholder="请输入系列名称"
            class="add-renovation-input"
            style="width: 200px"
            v-model.number="addSericeForm.seriesName"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序：" prop="sort" class="form-item">
          <el-input
            size="small"
            placeholder="请输入排序"
            class="add-renovation-input"
            style="width: 200px"
            v-model.number="addSericeForm.sort"
            type="number"
            onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode)))"
          ></el-input>
          <div class="sort-tip">数值越大，排序越靠前</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="seriesVisible = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="addSerice">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'banner',
  data() {
    return {
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '商城设置',
        secondTitle: '品牌管理'
      },
      list: [], // 轮播列表

      filter: {
        hotBrand: 0,
        brandName: ''
      },
      seriesVisible: false,
      seriesList: [],
      addSericeForm: {
        seriesName: '',
        sort: 0,
      },
      type: 'add',
      addSericevisible: false,
      brandId: null
    };
  },
  mounted() {
    // 获取列表
    this.getBrandList();
  },
  computed: {},
  methods: {
    // 切换页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getBrandList();
    },
    search(){
      this.currentPage = 1;
      this.getBrandList();
    },
    reset(){
      this.filter = {
        hotBrand: 0,
        brandName: ''
      };
      this.currentPage = 1;
      this.getBrandList();
    },
    // 获取轮播列表
    getBrandList() {
      this.loading++;
      this.httpGet(this.$root.getBrandList, {
        page: this.currentPage,
        size: this.size,
        ...this.filter,
      }).then(
        (res) => {
          this.loading--;
          this.list = res.list;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    changeBrandHot(id, hotBrand) {
      let str = '';
      if(hotBrand === 1){
        str = '取消';
      }
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>是否${str}设置该品牌为热门品牌？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPut(this.$root.changeBrandHot, {
          id,
          hotBrand: hotBrand === 1 ? 2 : 1
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getBrandList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    // 删除轮播图
    deleteBrand(id) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要删除该品牌吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpDelete(this.$root.deleteBrand, {
          id
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getBrandList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    getSeriesList(id){
      id && (this.brandId = id);
      this.loading++;
        this.httpGet(this.$root.getSeriesList, {
          brandId: this.brandId
        }).then(
          (res) => {
            this.loading--;
            this.seriesList = res;
            this.seriesVisible = true;
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
    },
    addSericeModal(){
      this.addSericeForm = {
        seriesName: '',
        sort: 0,
      };
      this.addSericevisible = true;
    },
    deleteSeries(id){
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要删除该系列吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpDelete(this.$root.deleteSeries, {
          id
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getSeriesList(null);
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    addSerice(){
      this.loading++;
        this.httpPost(this.$root.addSeries, {
          brandId: this.brandId,
          ...this.addSericeForm
        }).then(
          (res) => {
            this.loading--;
            this.addSericevisible = false;
            this.getSeriesList(null);
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
    },
    toDetail(type, id) {
      this.$router.push({
        name: 'brandDetail',
        query: {
          type,
          id
        }
      });
    },
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.banner-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 0 20px 20px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      .filter-box{
        flex-x();
        .left{
          flex-x(flex-start);
        }
        .btn-box{
          margin-left: 10px;
        }
      }

      // 按钮
      .btn {
        // width: 100px;
        display: inline-block;
        padding: 0 10px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin-bottom: 16px;
        // margin: 16px 0;
      }

      .tip {
        margin-left: 32px;
        color: #999;
      }

      // 表格按钮
      .table-btn {
        width: 65px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
      }

      .brand-pic {
        height: 36px;
        width: auto;
      }
    }
    .footer {
      width: 100%;
      padding: 24px;
      box-sizing: border-box;
      flex-x(flex-end);
      background: white;
    }
  }
  .series-box{
    .table-btn {
      width: 65px;
      height: 24px;
      line-height: 24px;
      color: gray3;
      font-size: 12px;
      margin-right: 8px;
      cancel-btn();
    }
    .add-btn{
      cursor: pointer;
      word(14px, #5E8CFF);
      margin-top: 16px;
    }
  }
  .form {
    margin-top: 30px;
    margin-bottom: 30px;
    padding-left: 40px;

    .sort-tip {
      word(14px, #c8c8c8);
      line-height: 20px;
    }
  }
}
</style>
